import { axiosGet, axiosPost } from "../../react_axios/Axios";
import {RAISE_MANUAL_FORM,MARK_MANUAL_FORM,raiseManualFormInvoiceUrl,markManualFormInvoicePaidUrl, headers, getVendorBasicDetailUrl, GET_VENDOR_BASIC_DETAIL, getVendorStaticListUrl,getVendorDashboardDataUrl, GET_VENDOR_STATIC_LIST, GET_VENDOR_DASHBOARD_DATA } from '../../utils/constants'


export const raiseManualForm_action = (ManualFormID, RecordID,InvoiceDocument) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')) != null && JSON.parse(sessionStorage.getItem('loginDataSS')) != '' && JSON.parse(sessionStorage.getItem('loginDataSS')).UserID != null && JSON.parse(sessionStorage.getItem('loginDataSS')).UserID != undefined && JSON.parse(sessionStorage.getItem('loginDataSS')).UserID != '' ? JSON.parse(sessionStorage.getItem('loginDataSS')).UserID : null,
            ExhibitionID: JSON.parse(sessionStorage.getItem("sessionExhibitionID")),
            ManualFormID: ManualFormID != '' ? parseInt(ManualFormID) : null,
            RecordID: RecordID != '' ? parseInt(RecordID) : null,
            InvoiceDocument: InvoiceDocument,
        }

        const res = await axiosPost(raiseManualFormInvoiceUrl, params, headers)

        dispatch({
            type: RAISE_MANUAL_FORM,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const markManualFormInvoicePaid_action = (ManualFormID, RecordID, IsPaid) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')) != null && JSON.parse(sessionStorage.getItem('loginDataSS')) != '' && JSON.parse(sessionStorage.getItem('loginDataSS')).UserID != null && JSON.parse(sessionStorage.getItem('loginDataSS')).UserID != undefined && JSON.parse(sessionStorage.getItem('loginDataSS')).UserID != '' ? JSON.parse(sessionStorage.getItem('loginDataSS')).UserID : null,
            ExhibitionID: JSON.parse(sessionStorage.getItem("sessionExhibitionID")),
            ManualFormID: ManualFormID != '' ? parseInt(ManualFormID) : null,
            RecordID: RecordID != '' ? parseInt(RecordID) : null,
            IsPaid: IsPaid,
        }

        const res = await axiosPost(markManualFormInvoicePaidUrl, params, headers)

        dispatch({
            type: MARK_MANUAL_FORM,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getVendorBasicDetail_action = (AccountID) => async (dispatch) => {

    try {
        const mapdata = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')) != null && JSON.parse(sessionStorage.getItem('loginDataSS')) != '' && JSON.parse(sessionStorage.getItem('loginDataSS')).UserID != null && JSON.parse(sessionStorage.getItem('loginDataSS')).UserID != undefined && JSON.parse(sessionStorage.getItem('loginDataSS')).UserID != '' ? JSON.parse(sessionStorage.getItem('loginDataSS')).UserID : null,
            AccountID: sessionStorage.getItem("AccountIDSS")
        }
        console.log("data----------", mapdata)
        const res = await axiosGet(getVendorBasicDetailUrl, mapdata, headers);

        dispatch({
            type: GET_VENDOR_BASIC_DETAIL,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const getVendorStaticList_action = (ExhibitionID) => async (dispatch) => {

    try {
        const mapdata = {
            ExhibitionID: ExhibitionID !='' ? ExhibitionID: null
        }
        console.log("data----------", mapdata)
        const res = await axiosGet(getVendorStaticListUrl, mapdata, headers);

        dispatch({
            type: GET_VENDOR_STATIC_LIST,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const getVendorDashboardData_action = (ExhibitionID) => async (dispatch) => {

    try {
        const mapdata = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')) != null && JSON.parse(sessionStorage.getItem('loginDataSS')) != '' && JSON.parse(sessionStorage.getItem('loginDataSS')).UserID != null && JSON.parse(sessionStorage.getItem('loginDataSS')).UserID != undefined && JSON.parse(sessionStorage.getItem('loginDataSS')).UserID != '' ? JSON.parse(sessionStorage.getItem('loginDataSS')).UserID : null,
            ExhibitionID: ExhibitionID !='' ? ExhibitionID: null
        }
        console.log("data----------", mapdata)
        const res = await axiosGet(getVendorDashboardDataUrl, mapdata, headers);

        dispatch({
            type: GET_VENDOR_DASHBOARD_DATA,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};